import ComponentsFactory from 'foundation/components-factory';
import ResetPasswordUrlComponent from './js/reset-password-url.component';

ComponentsFactory.getInstance().define('reset-password-url', ResetPasswordUrlComponent);
